// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../_css-loader@0.23.1@css-loader/index.js!./sweetalert2.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../_style-loader@0.13.2@style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../_css-loader@0.23.1@css-loader/index.js!./sweetalert2.css", function() {
			var newContent = require("!!../../_css-loader@0.23.1@css-loader/index.js!./sweetalert2.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/_sweetalert2@6.6.6@sweetalert2/dist/sweetalert2.css
// module id = 5
// module chunks = 0